import React, { useState } from 'react';
import Overlay from '../../../components/Overlay';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import { CategoriesSelectModal } from '../../CreativeAnalytics/CategoriesSelectModal';

import styles from './StaticReportModal.module.scss';

const FormGroup = ({ label, children, className = '' }) => (
  <div className={`${styles.formGroup} ${className}`}>
    <label className={styles.label}>{label}</label>
    <div className={styles.fieldContainer}>{children}</div>
  </div>
);

const SectionToggle = ({ active, label, onClick }) => (
  <button
    className={`${styles.sectionToggle} ${
      active ? styles.sectionToggleActive : ''
    }`}
    onClick={onClick}
  >
    <div className={styles.checkboxContainer}>
      <input
        type="checkbox"
        checked={active}
        readOnly
        className={styles.toggleCheckbox}
      />
    </div>
    <span className={styles.toggleLabel}>{label}</span>
  </button>
);

const LoadingAnimation = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.spinner}>
      <div className={styles.spinnerInner}></div>
    </div>
    <span className={styles.loadingText}>Generating your report...</span>
  </div>
);

export const StaticReportModal = ({
  close,
  submit,
  sharedReportId,
  loading,
  categorySettings,
  location,
  sharePayloadError,
  staticReportSections,
  toggleSection,
}) => {
  const [report_name, setName] = useState('');
  const [report_description, setDesc] = useState('');
  const [showCategoriesSelect, setShowCategoriesSelect] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [elementsToInclude, setElementsToInclude] = useState({
    visuals: true,
    table: false,
  });

  const isIncluded = (section) => {
    return !!staticReportSections?.[section];
  };

  const onSubmit = () => {
    submit({
      report_name,
      report_description,
      selectedCategories,
      elementsToInclude,
    });
  };

  const { protocol, hostname, port } = window.location;
  const rootUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  const url = `${rootUrl}/static-report${
    location === 'report_card' ? '-card' : ''
  }/${sharedReportId}`;

  console.log('test')
  return (
    <Overlay close={close} show>
      <Modal className={styles.modal} close={close}>
        <div className={styles.container}>
          <h3 className={styles.title}>Create Static Report</h3>

          {showCategoriesSelect && (
            <CategoriesSelectModal
              show={showCategoriesSelect}
              setShow={setShowCategoriesSelect}
              existing={selectedCategories}
              onConfirm={(update) => setSelectedCategories(update)}
              categorySettings={categorySettings}
            />
          )}

          {!!sharedReportId ? (
            <div className={styles.success}>
              <h3 className={styles.successTitle}>
                Report successfully created.
              </h3>
              <p className={styles.successMessage}>
                Click{' '}
                <a target="_blank" href={url} className={styles.link}>
                  here
                </a>{' '}
                to open and share.
              </p>
              <div className={styles.actions}>
                <Button
                  fullWidth
                  className={styles.confirmButton}
                  onClick={close}
                >
                  Confirm
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className={styles.form}>
                <div className={styles.formLeft}>
                  <FormGroup label="Report Name">
                    <input
                      className={styles.input}
                      value={report_name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup label="Report Description">
                    <textarea
                      className={styles.textarea}
                      value={report_description}
                      onChange={(e) => setDesc(e.target.value)}
                      rows="4"
                    />
                  </FormGroup>

                  {location === 'pfr' && (
                    <div className={styles.categorySelector}>
                      <button
                        className={`${styles.categoryToggle} ${
                          selectedCategories.length ? styles.active : ''
                        }`}
                        onClick={() => setShowCategoriesSelect(true)}
                      >
                        <span>Only include selected categories</span>
                        <input
                          type="checkbox"
                          checked={selectedCategories.length > 0}
                          readOnly
                          className={styles.checkbox}
                        />
                      </button>
                    </div>
                  )}
                </div>

                <div className={styles.formRight}>
                  <h6 className={styles.sectionHeader}>Sections to Include</h6>
                  <SectionToggle
                    active={isIncluded('summary_data')}
                    label="Summary Data"
                    onClick={() => toggleSection('summary_data')}
                  />
                  <SectionToggle
                    active={isIncluded('detail_data')}
                    label="Detail Data"
                    onClick={() => toggleSection('detail_data')}
                  />
                  <SectionToggle
                    active={isIncluded('analytics_intelligence')}
                    label="Analytics Intelligence"
                    onClick={() => toggleSection('analytics_intelligence')}
                  />
                </div>
              </div>

              {loading && <LoadingAnimation />}

              <div className={styles.actions}>
                <Button
                  onClick={close}
                  appearance="subtle"
                >
                  Cancel
                </Button>
                <Button
                  loading={loading}
                  onClick={onSubmit}
                >
                  Generate report
                </Button>
              </div>

              {sharePayloadError && (
                <div className={styles.error}>
                  <i className="fa-solid fa-circle-exclamation" />
                  <span>
                    Request contains too much data.
                    <br />
                    Please select fewer categories and try again.
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
    </Overlay>
  );
};
